import React from 'react';
import styled, { css } from 'styled-components';
import Item from '../../Course/components/Item';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { Text, Column, Title, Row } from '../../../theme/index';
import { Link } from 'react-scroll';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 2.5em 0;
`;

const BundleWrapper = styled.div`
  width: 50%;
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: 260px;
  margin: 0 auto;
  grid-gap: 20px;
  @media (max-width: 1100px) {
    width: 95%;
    margin: 1em auto;
  }
`;

const Div = styled.div`
  border: 1px solid #ffaf77;
  height: 0.5px;
  width: 60%;
  background-color: #ffaf77;
  margin: 0.5em 0;
`;

const StyledColumn = styled(Column)`
  width: 50%;
  height: 100%;
  align-items: flex-start;
  @media (max-width: 1100px) {
    width: 95%;
    align-items: center;
    margin: 1em auto;
  }
`;

const StyledTextColumn = styled(Column)`
  width: 75%;
  @media (max-width: 1100px) {
    width: 95%;
    text-align: center;
    align-items: center;
  }
`;

const StyledRow = styled(Row)`
  justift-content: center;
  @media (max-width: 1100px) {
    flex-direction: column;
  }
`;

const Icon = styled.i`
  font-size: 3em;
  color: #ffaf77;
  margin-right: 0.5em;
  @media (max-width: 500px) {
    display: none;
  }
  ${props =>
    props.down &&
    css`
      font-size: 2.5em;
      margin: 0;
      @media (max-width: 500px) {
        display: block;
      }
    `};
`;

function Bundle({ data: { bundles } }) {
  if (bundles && bundles.length >= 1) {
    return (
      <Wrapper>
        <StyledRow>
          <BundleWrapper>
            {bundles &&
              bundles.map((key, index) => {
                return (
                  <Item
                    key={index}
                    link={key.id && key.id}
                    img={
                      key.bundleCard &&
                      `https://media.graphcms.com/${key.bundleCard.handle}`
                    }
                    name={key.name}
                  />
                );
              })}
          </BundleWrapper>
          <StyledColumn>
            <Row alignitems="center">
              <Icon className="fas fa-asterisk" />
              <Title professionsub>Complete CE Bundle</Title>
            </Row>
            <Div />
            <StyledTextColumn>
              <Text profession color="#2b2b2b">
                {bundles && bundles[0].requirementsDescription}
              </Text>
            </StyledTextColumn>
          </StyledColumn>
        </StyledRow>
        <Link
          to="courses"
          activeClass="active"
          className="test1"
          spy={true}
          smooth={true}
          duration={500}
        >
          <Row
            justifycontent="center"
            margin="3em 0 0 0"
            style={{ cursor: 'pointer' }}
          >
            <Column alignitems="center">
              <Text margin="0" color="#2b2b2b">
                See all courses below
              </Text>
              <Icon down className="fas fa-angle-down" />
            </Column>
          </Row>
        </Link>
      </Wrapper>
    );
  } else {
    return null;
  }
}

export const bundles = gql`
  query bundles($state: String, $profession: String) {
    bundles(
      where: {
        professionPages_some: { state: $state, profession: $profession }
      }
    ) {
      id
      requirementsDescription
      bundleCard {
        handle
      }
    }
  }
`;

export default graphql(bundles, {
  props: ({ data }) => ({
    data,
  }),
  options() {
    let state = window.location.href.split('/')[4];
    state = state.replace(/-/g, ' ');
    let profession = window.location.href.split('/')[3];
    profession = profession.replace(/-/g, ' ');
    return {
      variables: {
        profession: profession,
        state: state,
      },
    };
  },
})(Bundle);



// WEBPACK FOOTER //
// ./src/components/screens/Profession/components/Bundle.jsx